import { render, staticRenderFns } from "./claim_approve.vue?vue&type=template&id=436a71e9&"
import script from "./claim_approve.vue?vue&type=script&lang=js&"
export * from "./claim_approve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports